import { ISunmiPrinterService } from './sunmi-printer.service';
import { Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ReceiptPrinter } from '@pos-common/services/system/receipt-printers/classes/receipt-printer.class';
import { MYPOS } from '@pos-common/constants/mypos.const';
import { SunmiDeviceModel } from '@pos-common/services/system/devices/sunmi/sunmi.service.model';

export class SunmiPrinterServiceMock extends ISunmiPrinterService {
  constructor(injector: Injector) {
    super(injector);
  }

  protected get discoverMethodName(): string {
    return '';
  }

  protected get pluginName(): string {
    return '';
  }

  protected get printMethodName(): string {
    return '';
  }

  protected get stopDiscoverMethodName(): string {
    return '';
  }

  protected discover(): Observable<ReceiptPrinter[]> {
    this.getPrinter();
    return this.printerList;
  }

  protected stopDiscover() {
    return Promise.resolve();
  }

  private getPrinter(): Observable<ReceiptPrinter[]> {
    // const { isSunmiDevice, hasPrinter } = this.sunmiService;
    // const { modelName } = this.sunmiService;

    const isSunmiDevice = true;

    if (isSunmiDevice) {
      const deviceName = 'Sunmi';
      const deviceType = SunmiDeviceModel.V2sPlus;

      const hasPrinter = true;

      if (hasPrinter) {
        const printer = new ReceiptPrinter({
          printerName: deviceName,
          deviceName,
          deviceType,
          ipAddress: MYPOS.IP_ADDRESS,
          isActive: true,
          macAddress: MYPOS.MAC_ADDRESS,
          printerNameForModelPick: 'SUNMI_58mm',
          target: MYPOS.TARGET,
        });

        this.handleDiscover([printer]);
        return;
      }
    }
    this.handleDiscover([]);
  }

  print(device: ReceiptPrinter, receipt: any[]) {
    return Promise.resolve();
  }
}
